class BrowserUtils {
    abrirNovaAbaEmBranco() {
        return window.open('', '_blank');
    }

    atualizarAbaLocation(aba, location) {
        if (!aba) return;

        if(!location) aba.close();

        aba.location.href = location;
    }
}

export default new BrowserUtils();